import React from "react";

const PaymentSuccess = () => {
  return (
    <div className="payment-success-container">
      <h2>Payment Successful!</h2>
      <p>Please drop an email to equityfinx@gmail.com with below details.</p>
      <p>Subject: Payment Details Confirmation
        <br/>
        <br/>
        Hello,<br/>
        Please find the payment details below:<br/>
        Amount (AED): [Amount]<br/>
        Name: [Name]<br/>
        Mobile: [Mobile Number]<br/>
        <br/>
        I acknowledge that this payment is for Crypto Portfolio Management Services. I understand that the fiat currency (AED) will be converted to USDT at the prevailing exchange rate and subsequently used to purchase the respective cryptocurrencies.<br/>
        <br/>
        Best regards,<br/>
        [Your Name]<br/>
      </p>
    </div>
  );
};

export default PaymentSuccess;
